import { render, staticRenderFns } from "./ConstructionDashboard.vue?vue&type=template&id=7455e8ae&scoped=true&lang=pug&"
import script from "./ConstructionDashboard.vue?vue&type=script&lang=ts&"
export * from "./ConstructionDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./ConstructionDashboard.vue?vue&type=style&index=0&id=7455e8ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7455e8ae",
  null
  
)

export default component.exports